<template>
  <div class="flex">
    <loader :task="task" />
    <q-btn
      v-for="socialSite in socialSites"
      :key="socialSite.id"
      :size="size"
      flat
      round
      :class="'q-mx-' + size"
      @click="toggle(socialSite.id)">
        <site-icon
          :social-site="socialSite"
          :color="isSelected(socialSite.id) ? '' : 'grey-6'"
          :size="size"
        />
    </q-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { SocialSite } from '@/type';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './site-repository';
import SiteIcon from './SiteIcon.vue';

interface Data {
  task: Promise<SocialSite[]>|null,
  socialSites: SocialSite[],
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  components: { Loader, SiteIcon },
  props: {
    modelValue: [Number, Array as () => number[]],
    size: {
      type: String,
      default: 'md',
    },
  },
  data(): Data {
    return {
      task: null,
      socialSites: [],
    };
  },
  computed: {
    multiple(): boolean {
      return _.isArray(this.modelValue);
    },
  },
  methods: {
    load() {
      this.task = repository.findAll();
      this.task.then((socialSites: SocialSite[]) => {
        this.socialSites = socialSites;
        this.$emit('loaded', socialSites);
      });
    },
    select(id: number) {
      if (this.isSelected(id)) return;
      if (this.multiple) {
        this.$emit('update:modelValue', (this.modelValue as number[]).concat([id]));
      } else {
        this.$emit('update:modelValue', id);
      }
    },
    deselect(id: number) {
      if (this.multiple && (this.modelValue as number[]).length === 1) {
        return;
      }
      let value = null;
      if (this.multiple) {
        value = (this.modelValue as number[]).filter(ssId => ssId !== id);
      }
      this.$emit('update:modelValue', value);
    },
    selectAll() {
      this.$emit('update:modelValue', this.socialSites.map(ss => ss.id));
    },
    isSelected(id: number): boolean {
      if (_.isNumber(this.modelValue)) {
        return this.modelValue === id;
      }
      if (_.isArray(this.modelValue)) {
        return this.modelValue.includes(id);
      }
      return false;
    },
    toggle(id: number) {
      if (this.isSelected(id)) {
        this.deselect(id);
      } else {
        this.select(id);
      }
    },
  },
  created() {
    this.load();
  },
});
</script>
